function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { guid } from '@bydesign-ui/utils';
import { Emitter } from '@bydesign-ui/hooks';
export var SubMenu = function (_Emitter) {
  _inherits(SubMenu, _Emitter);

  var _super = _createSuper(SubMenu);

  function SubMenu(rootMenu, options, parent, insId) {
    var _this;

    _classCallCheck(this, SubMenu);

    _this = _super.call(this);
    _this.level = 1;
    _this.parent = null;
    _this.itemMap = {};
    _this.id = '';
    _this.disposed = false;
    _this.parent = parent;
    _this.rootMenu = rootMenu;
    _this.insId = insId || guid();

    _this.updateSubMenuOptions(options);

    _this.init();

    return _this;
  }

  _createClass(SubMenu, [{
    key: "updateSubMenuOptions",
    value: function updateSubMenuOptions(options) {
      var id = options.id;
      this.id = id;
    }
  }, {
    key: "getInsId",
    value: function getInsId() {
      return this.insId;
    }
  }, {
    key: "getInsIdsPath",
    value: function getInsIdsPath() {
      var insIds = [this.insId];

      if (this.parent) {
        return this.parent.getInsIdsPath().concat(insIds);
      }

      return insIds;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      return this.level;
    }
  }, {
    key: "isSubMenu",
    value: function isSubMenu() {
      return true;
    }
  }, {
    key: "setLevel",
    value: function setLevel() {
      if (this.parent) {
        this.level = this.parent.getLevel() + 1;
      } else {
        this.level = 1;
      }
    }
  }, {
    key: "setActive",
    value: function setActive() {
      this.rootMenu.setActiveMenus(this.id);

      if (this.parent != null) {
        this.parent.setActive();
      }
    }
  }, {
    key: "getActive",
    value: function getActive() {
      var activeMenus = this.rootMenu.getActiveMenus();
      return activeMenus.indexOf(this.id) > -1;
    }
  }, {
    key: "getOpened",
    value: function getOpened() {
      return this.opened;
    }
  }, {
    key: "updateOpened",
    value: function updateOpened(open) {
      var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.doSetOpened(open, deep);
      this.rootMenu.emitOpenMenusUpdate();
    }
  }, {
    key: "setOpened",
    value: function setOpened(open) {
      var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.doSetOpened(open, deep);
      this.rootMenu.emitOpenMenusUpdate();
      this.rootMenu.emitOpenMenusChange();
    }
  }, {
    key: "updateParentOpenedState",
    value: function updateParentOpenedState(open) {
      var parent = this.parent;

      while (parent) {
        parent.updateOpenedState(open);
        parent = parent.parent;
      }
    }
  }, {
    key: "updateChildOpenedState",
    value: function updateChildOpenedState(open) {
      var _this2 = this;

      Object.keys(this.itemMap).forEach(function (insId) {
        var subMenu = _this2.itemMap[insId];

        if (!subMenu.isSubMenu()) {
          return;
        }

        var opened = subMenu.getOpened();

        if (open !== opened) {
          subMenu.updateOpenedState(open);
          subMenu.updateChildOpenedState(open);
        }
      });
    }
  }, {
    key: "updateOpenedState",
    value: function updateOpenedState(open) {
      if (this.opened === open) {
        return;
      }

      this.rootMenu.setOpen(this.insId, this.id, open);
    }
  }, {
    key: "register",
    value: function register(item) {
      var id = item.getInsId();

      if (this.itemMap[id]) {
        return;
      }

      this.itemMap[id] = item;
    }
  }, {
    key: "unregister",
    value: function unregister(item) {
      var id = item.getInsId();

      if (!this.itemMap[id]) {
        return;
      }

      delete this.itemMap[id];
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.disposed) {
        return;
      }

      if (this.parent) {
        this.parent.unregister(this);
      }

      this.rootMenu.unregisterSubMenu(this);
      this.disposed = true;
    }
  }, {
    key: "init",
    value: function init() {
      this.setLevel();

      if (this.parent) {
        this.parent.register(this);
      }

      this.rootMenu.registerSubMenu(this);
    }
  }, {
    key: "doSetOpened",
    value: function doSetOpened(open) {
      var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.rootMenu.getAccordion()) {
        if (this.parent) {
          this.parent.updateChildOpenedState(false);
        } else {
          this.rootMenu.setOpenIds([]);
        }
      }

      if (deep) {
        if (open && this.parent) {
          this.updateParentOpenedState(open);
        } else if (!open) {
          this.updateChildOpenedState(open);
        }
      }

      this.updateOpenedState(open);
    }
  }, {
    key: "opened",
    get: function get() {
      return this.rootMenu.isOpened(this.id);
    }
  }]);

  return SubMenu;
}(Emitter);